export const quoteLevelConstants = {

    garIndicators : {
        no : 'N',
        yes : 'Y',
        ignored: 'I',
        beaten: 'B',
        featured: 'F'
    },
    maritalStatus: {
        single: 'S',
        married: 'M',
        registeredCP: 'CP',
        divorced: 'D',
        widowed: 'W',
        seperated: 'SE'
    },
    radioToggleYesNo: {
        yes: 'Y',
        no: 'N'
    },
    transferTypes: {
        omo: 'OMO',
        ivpp: 'IVPP',
        internal: 'INTERNAL'
    },
    sourceCode: {
        aegon: 'H',
        aon: 'M',
        external: 'B',
        hsbc: 'R',
        landG: 'I',
        pensionBee: 'L',
        phoenixLife: 'O',
        prudential: 'K',
        reAssure: 'J',
        sloc: 'F',
    },
    products: {
        lta : 'C',
        corp: 'G',
        ftrp: 'H'
    },
    sources: {
        landG: 'L&G',
        legalAndGeneral: 'Legal & General',
        aegon: 'Aegon',
        aon: 'Aon',
        external: 'External',
        pensionBee: 'PensionBee',
        prudential: 'Prudential',
        reAssure: 'ReAssure',
        sloc: 'Sun Life Financial of Canada'
    }
};
